import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { ApiService } from '../../custom-material/Services/';
import { ObjectifModel, ActionModel, UserModel } from '../../main/Models';
import { ActionComponent } from '../action/action.component';

import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { globalData } from 'src/app/main/Models/global.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { toollist } from './objectif.tool';
import { ObjectifDoughnutComponent } from '../objectif-doughnut/objectif-doughnut.component';

@Component({
  selector: 'rm-objectif',
  templateUrl: './t_objectif.component.html',
  styleUrls: ['./objectif.component.less']
})
export class ObjectifComponent implements OnInit {

  //@Input('objectif') 
  objectif:ObjectifModel;
  //@Output() closeTriggered: EventEmitter<ObjectifModel> = new EventEmitter();

  mod:string = 'list';  //list | kanban
  showManual:boolean = false;

  openedAction: ActionModel = null;
  newAction: ActionModel = null;

  actionTeamsList:string[] = [];

  @ViewChildren('kanbanAction') kanbanActions!: QueryList<ActionComponent>;
  @ViewChild('doughnut') doughnutChart: ObjectifDoughnutComponent;

  chartValues = [];
  


  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    public gd: globalData
    ) { 
      this.gd.toollist = [...toollist];
      this.gd.toolService = this;
      this.gd.showChooser = false;
    }

  ngOnInit() { 
  	//TODO load IndiGroup to show its name

    this.loadObjectif().then(()=>{
      this.gd.headerTitle = 'Management - '+this.objectif.name;
      this.gd.headerIcon = 'multiline_chart';
      this.gd.headerBuilding = this.objectif.building;
      
      if(!this.objectif.actions.length) this.loadActions();
      if(!this.objectif.users.length) this.loadUsers();
    });

  }
  /*ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }*/
  ngOnDestroy()
  {
    this.save();
  }

  close()
  {
    /*this.objectif.showIndicator = false;
  	this.closeTriggered.emit(this.objectif);*/
    //this.router.navigate(['..']);
    window.history.go(-1);
  }

  loadObjectif()
  {
    return new Promise((resolve, reject)=>{
      let objectifID = +this.route.snapshot.params['objectif'];
      if(this.gd.current!= undefined 
      && this.gd.current.constructor.name == 'ObjectifModel'
      && this.gd.current.id == objectifID) {
        this.objectif = this.gd.current;
        resolve(true);
      }

      this.snackBar.open('Chargement en cours');
      this.apiService.getOneFromServer('objectif',objectifID)
      .then(s => s.subscribe((response:any) => {
        this.objectif = new ObjectifModel(response);
        this.snackBar.dismiss();
        resolve(true);
      }));
    });
  }

  save()
  {
    this.objectif.ratio = this.chartValues.join('-');
    
    this.apiService.UpdateToServer('objectif', this.objectif.export())
      .then((s)=>{s.subscribe((response:any)=>{
        this.objectif.origUsers = this.objectif.currentUsers;
      });})
  }
  

  loadActions()
  {
  	let params = this.apiService.createParams({objectif: this.objectif.id}, 'eq')
  	this.apiService.getFromServer('action', params)
    	.then(s=>s.subscribe((response:any)=>{
    		for( let i in response._embedded.action) {
    			let action = new ActionModel(response._embedded.action[i]);
          this.objectif.actions.push(action);
          //this.actionTeamsList.push('actionTeam'+action.id);
          //this.actionTeamsList.push('actionTeamK'+action.id);
    		}
        setTimeout(()=>{this.sortActions();}, 50);
    	}));
  }

  sortActions()
  {
    this.actionTeamsList = ['openedActionTeam'];
    this.objectif.actions
          .sort((a:ActionModel,b:ActionModel)=>{
            if(a.status==b.status) return (b.start>a.start) ? 1 : -1;
            return a.status-b.status;
          })
      .forEach((a:ActionModel)=>{
        this.actionTeamsList.push('actionTeam'+a.id);
        this.actionTeamsList.push('actionTeamK'+a.id);
      });

    this.todoActions.forEach((a:ActionModel, i:number)=>{
      a.actionPlace = i;
    });
    this.wipActions.forEach((a:ActionModel, i:number)=>{
      a.actionPlace = i;
    });
    this.finnishedActions.forEach((a:ActionModel, i:number)=>{
      a.actionPlace = i;
    });

    this.chartValues = [
      this.todoActions.length,
      this.wipActions.length,
      this.finnishedActions.length,
      this.canceledActions.length,
    ];
    setTimeout(()=>{this.doughnutChart.calculateData();}, 50);
  }

  createNewAction()
  {
    this.setModList();
    this.openedAction = new ActionModel({}, true);
    //this.objectif.actions.push(new ActionModel({}, true));
  }
  addAction(action:ActionModel)
  {
      this.objectif.actions.push(action);
      //this.actionTeamsList.push('actionTeam'+action.id);
      //this.actionTeamsList.push('actionTeamK'+action.id);
      this.sortActions();
  }

  deleteAction(action:ActionModel, index:number)
  {
    this.apiService.DeleteFromServer('action', action)
      .then((s)=>{
        s.subscribe((response:any)=>{
        this.objectif.actions.splice(index, 1);
        this.sortActions();
      });});
  }

  openAction(a:ActionModel)
  {
    this.openedAction = a;
    this.actionTeamsList.push('openedActionTeam');
  }


  get todoActions()
  {
    return this.objectif.actions.filter((a:ActionModel)=>{return (a.status==0)})
              .sort((a:ActionModel, b:ActionModel)=>{ return a.actionPlace - b.actionPlace});
  }
  get wipActions()
  {
    return this.objectif.actions.filter((a:ActionModel)=>{return (a.status==1)})
              .sort((a:ActionModel, b:ActionModel)=>{ return a.actionPlace - b.actionPlace});
  }

  get finnishedActions()
  {
    return this.objectif.actions.filter((a:ActionModel)=>{return (a.status==2)})
              .sort((a:ActionModel, b:ActionModel)=>{ return a.actionPlace - b.actionPlace});
  }

  get canceledActions()
  {
    return this.objectif.actions.filter((a:ActionModel)=>{return (a.status==-2)})
              .sort((a:ActionModel, b:ActionModel)=>{ return a.actionPlace - b.actionPlace});
  }


  drop(event: CdkDragDrop<string[]>) 
  {

    let elementId = event.item.element.nativeElement.id.split('-');
    let list = elementId[0];
    let index = elementId[1];
    let action = this[list+'Actions'][index];

    let newListId = event.container.element.nativeElement.id;
    let newList;

    switch (newListId) {
      case "todoList":
        action.actionStatus = 0;
        newList = this.todoActions;
        break;
      
      case "wipList":
        action.actionStatus = 1;
        newList = this.wipActions;
        break;

      case "finnishedList":
        action.actionStatus = 2;
        newList = this.finnishedActions;
        break;

      default:          
        break;
    }

    if(event.currentIndex >= newList.length-1) {//last place
      action.actionPlace = newList.length; //place at the end
    } else { //other place
      for(let i:number=event.currentIndex; i<newList.length; i++) { //move all actions since this place
        newList[i].actionPlace = i+1;
      }
      action.actionPlace = event.currentIndex;
    }

    setTimeout(()=>{ this.sortActions(); }, 200);
    
  }


  get firstActionDate()
  {
    let firstDate;
    this.objectif.actions.forEach((a:ActionModel)=>{
      if(!firstDate || a.startDate < firstDate) firstDate = a.startDate;
    });
    return firstDate;
  }

  get lastActionDate()
  {
    let lastDate;
    this.objectif.actions.forEach((a:ActionModel)=>{
      if(!lastDate || a.endDate > lastDate) lastDate = a.endDate;
    });
    return lastDate;
  }

  get totalActionBudget()
  {
    let total = 0;
    this.objectif.actions.forEach((a:ActionModel)=>{
      if(a.budget) total += +a.budget;
    });
    return total;
  }


  //Actors
  loadUsers()
  {
    let params = this.apiService.createParams({objectifs: this.objectif.id});
    this.apiService.getFromServer('user', params)
      .then(s=>s.subscribe((response:any)=>{
        this.objectif.users = [];
        for( let i in response._embedded.user) {
          let user = new UserModel(response._embedded.user[i]);
          this.objectif.origUsers.push(user);
          this.objectif.currentUsers.push(user);
        }
      }));
  }

  unfoldAll()
  {
    this.kanbanActions.forEach((a)=>{a.fold=false});
  }
  foldAll()
  {
    this.kanbanActions.forEach((a)=>{a.fold=true});
  }

  setModList() {
    this.gd.toollist = [...toollist];
    this.mod='list';
  }
  setModKanban() { 
    this.gd.toollist = [...toollist];
    this.gd.toollist.unshift(
      {
          "Type": "Icon",
          "Color": "disabled",
          "Icon": "unfold_more",
          "Label": "Tout déplier",
          "Method": "unfoldAll",
          "Condition": "isModKanban"
      },
      {
          "Type": "Icon",
          "Color": "disabled",
          "Icon": "unfold_less",
          "Label": "Tout plier",
          "Method": "foldAll",
          "Condition": "isModKanban"
      }
    );
    this.mod='kanban'}
  setModIndic() { 
    this.gd.toollist = [...toollist];
    this.mod='indic';
  }
  isModList() { return this.mod=='list'}
  isModKanban() { return this.mod=='kanban'}
  isModIndic() { return this.mod=='indic'}
  inIndicAvailable() { return this.objectif.answer!=null }

  toggleManual() { this.showManual = !this.showManual}

  goBack()
  {
    if(this.gd.back != undefined) {
      let goto = ['/','rm','generator', this.gd.back.diagnostic];
      setTimeout(()=>{
        this.router.navigate(goto);
      },100);
    } else {
      this.router.navigate(['/','rm','objectifs']);
    }
  }
}
